import React from "react";
import { EksempeloppgaverApp } from "./Main";
import { RenderApp } from "../common/components/RenderApp";
import { AppContainer } from "../common/components/AppContainer";

RenderApp(
	<AppContainer hideLogoutButton={true}>
		<EksempeloppgaverApp />
	</AppContainer>
);
